import styled from "styled-components";

export const ArticelList = styled.ul`
  gap: 12px;
  height: calc(100vh - 56px);
  display: flex;
  padding: 16px;
  overflow-y: auto;
  flex-direction: column;
`;
